import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'preloader-component',
  templateUrl: 'preloader.component.html',
  styleUrls: ['preloader.component.scss']
})
export class PreloaderComponent {
  @Input() isFull: boolean = true;
}
